import { defineComponent as _defineComponent } from 'vue';
import { useHead } from '@vueuse/head';
import { pwa } from '@/config';
import { enLocale, zhLocale } from '@/i18n';

import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { computed, defineAsyncComponent, reactive, watchEffect } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const route = useRoute();
    const {
      locale: language
    } = useI18n();
    const locale = computed(() => language.value === 'en' ? enLocale : zhLocale);
    const VabUpdate = defineAsyncComponent(() => import('@/plugins/VabUpdate/index.vue'));
    const siteData = reactive({
      description: ''
    });
    watchEffect(() => {
      siteData.description = `${'Vue'} ${'Admin'} ${'Plus'}-${route.meta.title} - 简介、官网、首页、文档和下载 - 前端开发框架`;
    });
    useHead({
      meta: [{
        name: `description`,
        content: computed(() => siteData.description)
      }]
    });
    const __returned__ = {
      route,
      language,
      locale,
      VabUpdate,
      siteData,
      get pwa() {
        return pwa;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});